import axios from 'axios'
import env from '../env'
const request = axios.create({
    // 配置公共请求部分
    baseURL: env.basUrl,
    // 设置请求前数据
    headers: { "Content-type": "application/json" },
    // Authorization":"Bearer "+授权码
    transformRequest: [function (data) {
        return data
    }],
    // 响应拦截数据
    transformResponse: [function (data) {
        // console.log("响应数据", JSON.parse(data));
        if (JSON.parse(data).status_code == 401) {
            alert("登录状态已过期请重新登录")
            let strong = window.localStorage;
            strong.removeItem("token")
            location.reload();
            return
        }
        return data
    }]
})

request.interceptors.request.use(function (request) {
    // 添加token
    // console.log("request,请求数据",request);
    let storage = window.localStorage;
    let token = storage.getItem('token')
    if (token) {
        request.headers.Authorization = `Bearer ${token}`
    }
    return request
})

request.interceptors.response.use(function (response) {
    
    return response
})

export default request